<app-header [pcnOnly]="shellConfig?.pcnOnly"></app-header>
<router-outlet (activate)="routeActivate()"></router-outlet>
<app-footer [showTranslationAssistanceLink]="shellConfig?.showTranslationAssistanceLink"></app-footer>
<app-notification-banner [notificationBanners]="bannerDetails"></app-notification-banner>
